export const getEmbedSnippet = widgetUrl => {
  return `<div id="reveni-tracking"></div>\n<script defer src="${widgetUrl}"></script>`
}

export const getUrlParametersSnippet = storeId => {
  return `?order_id={order_id}&email={customer_email}&store=${storeId}&language={language}`
}
